export const SET_CATEGORIES = 'setCategories'
